module.exports = __webpack_public_path__ + "images/generic-sim-number.c23011e45f1296ac107f2e235eaabccf.png";